/* eslint-disable no-restricted-syntax */
import { parse } from 'helpers/dates';
import NBXAccounts from 'services/accounts.service';

const transform = it => ({
  id: it.referralId,
  created: parse(it.createdAt),
  inCurrency: it.asset,
  inAmount: it.amount,
  market: 'NBX',
  type: it.rewardType
});

export async function fetchReferrals(year) {
  const taxReportItems = [];
  for await (const month of NBXAccounts.getReferralTaxReports(year)) {
    taxReportItems.push(...month.map(transform));
  }
  return taxReportItems;
}
